export const BASKET_UPDATE = 'basketUpdate'
export const BASKET_OPEN = 'basketOpen'

export const UPDATE_IFRAME_EMBED_URL = 'updateIframeEmbedUrl'
